import React from 'react';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from "react-redux";
import './index.css';
import App from './App';
import { Store } from "./redux/Store";
import reportWebVitals from './reportWebVitals';
import { BrandProvider } from './context/BrandContext';

// Google Analytics (gtag) - Load globally on all pages
const GA_ID = 'G-2SS494ZPXV'; // Replace with your actual GA Measurement ID
if (GA_ID) {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  const inline = document.createElement('script');
  inline.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${GA_ID}');`;
  document.head.appendChild(inline);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
console.log(process.env, "env values");

root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
        <BrandProvider>
          <App />
          <ToastContainer />
        </BrandProvider>
      </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
